/* eslint-disable indent */
import { TitleWithTooltip } from '../components/DashboardRetailMediaCampaigns/cards/TitleWithTooltip'
import {
  availableNtbMetrics,
  NtbMetric,
  NtbMetricKey,
  ntbMetricLabel,
  NtbTooltipValues,
  translateNtbKey
} from './ntbMetrics'

type NtbFormatted = Partial<Record<NtbMetricKey, string | number>> | null

export type NtbCard<TType extends string> = {
  id: string
  label: string
  title: JSX.Element
  value: string | number
  compareValue?: string | number | null
  type: TType
  badge?: string
}

type BuildNtbCardsProps<TType extends string> = {
  availableMetrics?: NewMetricsAvailability
  formatted?: NtbFormatted
  compareFormatted?: NtbFormatted
  tooltipValues: NtbTooltipValues
  badge?: string
  /** dashboard usa o tipo snake_case, a view de campanha o camelCase */
  typeOf: (metric: NtbMetric) => TType
  emptyValue?: string | number
}

/** Os 4 cards de NTB, só os disponíveis; a métrica ausente vira traço. */
export const buildNtbCards = <TType extends string>({
  availableMetrics,
  formatted,
  compareFormatted,
  tooltipValues,
  badge,
  typeOf,
  emptyValue = '-'
}: BuildNtbCardsProps<TType>): NtbCard<TType>[] =>
  availableNtbMetrics(availableMetrics).map(metric => ({
    id: `card-${metric.rawKey}`,
    label: ntbMetricLabel(metric),
    title: (
      <TitleWithTooltip
        metric={metric.key}
        tooltipValues={tooltipValues}
        cardLabel={
          metric.cardLabelOf
            ? translateNtbKey(`rm:metrics.${metric.cardLabelOf}`)
            : undefined
        }
      />
    ),
    value: formatted?.[metric.key] ?? emptyValue,
    compareValue: compareFormatted?.[metric.key],
    type: typeOf(metric),
    badge
  }))
